export enum CAMPAIGN_STATUSES {
    ACTIVE = 'active',
    FINISHED = 'finished'
}

export enum CAMPAIGN_TYPES {
    FRUIT = 'fruit',
    PLANT = 'plant'
}